<template>
        <div v-if="!columnFeatures.editable" >
            {{ value || '--' }}
        </div>
        <input
        v-else-if="columnFeatures.type==='DATE'"
        type="date"
        v-model="value"
        :disabled="!edit"
        class="table-input"
       :placeholder="'Enter '+ columnFeatures.label"
        @change="updateRowData"
        />
        <input
        v-else-if="columnFeatures.type==='NUMBER'"
        type="number"
        v-model="value"
        class="table-input"
        :disabled="!edit"
        :placeholder="'Enter '+ columnFeatures.label"
        @change="updateRowData"
        />

    <check-box  v-else-if="columnFeatures.type==='BOOLEAN'" :checked="value" :disabled="!edit"   @change="updateRowData" />
       <input
        v-else
        type="text"
        v-model="value"
        class="table-input"
        :disabled="!edit"
        :placeholder="'Enter '+ columnFeatures.label"
        @change="updateRowData"
        />
</template>

<script>
import checkBox from '@/components/common/checkbox.vue'
export default {
  name: 'qcTableCell',
  components: {
    checkBox
  },
  data () {
    return {
      value: this.item
    }
  },
  props: {
    item: {
      type: String
    },
    columnFeatures: {
      type: Object,
      required: true
    },
    tableFieldId: {
      type: String,
      required: true
    },
    rowIndex: {
      type: Number,
      required: true
    },
    columnIndex: {
      type: Number,
      required: true
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateRowData (value) {
      if (this.columnFeatures.type === 'BOOLEAN') {
        this.value = value
      }
      this.$emit('updateRowData', {
        type: this.columnFeatures.type,
        value: this.value,
        tableFieldId: this.tableFieldId,
        columnIndex: this.columnIndex,
        rowIndex: this.rowIndex
      })
    }
  },
  watch: {
    item (val) {
      this.value = val
    }
  }
}
</script>

<style scoped lang="scss">
            .table-input {
              width: 100%;
              height: 36px;
              border: 1px solid #d1d5db;
              border-radius: 4px;
              padding: 0 12px;
              font-size: var(--text-base);
              background-color: #f3f4f6;
              color: #6b7280;

              &:focus {
                outline: none;
                border-color: #3b82f6;
                box-shadow: 0 0 0 1px #3b82f6;
                background-color: white;
                color: #374151;
              }
            }
</style>
